export const checkIfShouldDisableSaveButton = data => {
  const isAllFilled = data.every(
    question =>
      question.description && question.choices.every(choice => choice),
  )
  return !isAllFilled
}



// WEBPACK FOOTER //
// ./src/Components/PitchQuestionsForm/container/util.js